import { Box } from '@betterment/samba-react';

export const LeadingIcon: React.FC<{ url: string }> = ({ url }) => (
  <Box css={{ width: '36px', height: '36px' }}>
    <img src={url} alt="" />
  </Box>
);
